import { useEffect } from 'react';

import { CartSummaryMap } from '@/components/modules/_shared/CartSummary/maps/CartSummary.map';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useAutoUpdateCartSummaryData = () => {
  const {
    state: { cart },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  useEffect(() => {
    updateCartSummaryData();
  }, [cart]);

  const updateCartSummaryData = () => {
    if (!cart) return;

    const showCartSummary = !!cart.currency;
    const newCartSummaryData = showCartSummary ? CartSummaryMap.fromCartToCartSummary(cart) : undefined;

    updateApplicationContext({ cartSummaryData: newCartSummaryData });
  };
};
